import { render } from "./UpdateScreen.vue?vue&type=template&id=147627ba&scoped=true&ts=true"
import script from "./UpdateScreen.vue?vue&type=script&lang=ts"
export * from "./UpdateScreen.vue?vue&type=script&lang=ts"

import "./UpdateScreen.vue?vue&type=style&index=0&id=147627ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147627ba"]])

export default __exports__